import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { BeneficiaryDependentDto } from '../../../../../modules/beneficiaries/dtos/beneficiary-dependent';
import { BeneficiaryWalletDto } from '../../../../../modules/beneficiaries/dtos/beneficiary-wallet';
import { EnumUtils } from '../../../../../utils/enum.utils';

@Component({
	selector: 'app-dependent-info',
	styleUrls: ['./dependent-info.component.scss'],
	templateUrl: './dependent-info.component.html',
})
export class DependentInfoComponent implements OnInit {
	@Input() beneficiaryType: string = '';
	@Output() deleteDependent: EventEmitter<BeneficiaryDependentDto> =
		new EventEmitter();
	@Input() dependent?: BeneficiaryDependentDto | null;

	@Output() editBenefits: EventEmitter<BeneficiaryDependentDto> =
		new EventEmitter();
	@Output() editDependent: EventEmitter<string> = new EventEmitter();
	@Input() organizationId: string = '';

	dentalBenefitData: BeneficiaryWalletDto | null = null;
	healthBenefitData: BeneficiaryWalletDto | null = null;
	isDisabledButton: boolean = false;

	getDependentType(): string {
		const dependentType = this.dependent?.typeKinship;

		if (!dependentType) {
			return '';
		}

		if (!isNaN(Number(dependentType))) {
			return (
				EnumUtils.getKinship(
					EnumUtils.getKinshipFromNumberValue(dependentType),
				) ?? ''
			);
		} else {
			return EnumUtils.getKinship(dependentType.toString()) ?? '';
		}
	}

	getDependentUrl(): string {
		return `/organizacoes/${this.organizationId}/beneficiarios/${
			this.dependent?.id
		}`;
	}

	ngOnInit() {
		this.dentalBenefitData =
			this.dependent?.benefits.find((benefit) => benefit.is_dental) || null;
		this.healthBenefitData =
			this.dependent?.benefits.find((benefit) => benefit.is_health) || null;

		this.isDisabledButton =
			this.beneficiaryType === 'inativo' ||
			this.beneficiaryType === 'aposentado';
	}

	onDeleteDependent() {
		if (this.dependent) {
			this.deleteDependent.emit(this.dependent);
		}
	}

	onEditBenefits(): void {
		if (this.dependent) {
			this.editBenefits.emit(this.dependent);
		}
	}

	onEditDependent(): void {
		if (this.dependent) {
			this.editDependent.emit(this.dependent.id);
		}
	}
}
